import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('Roles');

export const roleQueries = {
  selectAll: baseQuery
};
